import React, {useRef, useState} from 'react'
import {useAppDispatch} from "../../../../redux/reducer/store";
import JourneyDayCard, {JourneyOverviewDayCardProps} from "../journey-day-card/JourneyDayCard";
import './styles.css'
import {addDayToJourney, addPersonToJourney, changeJourneyDuration} from "../../../../redux/reducer/journey";
import {JourneyDnDCommonProps} from "../../common";
import {IconButton, Text, TextButton} from "atmosfair-ui";
import groupBy from "lodash/groupBy";
import {get} from "lodash";
import {createArrayFromNumber} from "../../../../utils/common";
import {AllActivityTypesArray} from "../../../../types-enums/activity";
import '../styles.css'
import {DurationProps} from "../../../../types-enums/activity-common-properties";
import {getDurationInDaysOrNights} from "../../../../utils/getter/common";
import {useDndMonitor} from "@dnd-kit/core";

interface JourneyOverviewProps extends JourneyDnDCommonProps {
    altKeyPressed: boolean,
    onDeleteDay: (day: number) => void,
    journeyDuration: DurationProps,
    onDayArrow: JourneyOverviewDayCardProps["onDayArrow"],
    setAvoidRecalculationThroughUseEffect: () => void,
    travelComponentActivities?: AllActivityTypesArray,
    journeyPersonCount: number,
}

const JourneyOverview = ({
                             isRecalculatingActivityEmissions,
                             onActivityArrow,
                             activities,
                             altKeyPressed,
                             onDeleteActivity,
                             onDeleteDay,
                             onDayArrow,
                             journeyDuration,
                             hasExactDates,
                             draggingActivity,
                             setAvoidRecalculationThroughUseEffect,
                             travelComponentActivities,
                             journeyPersonCount
                         }: JourneyOverviewProps) => {
    const [hoveredId, setHoveredId] = useState<string | null>(null)
    const dispatch = useAppDispatch()
    const activitiesGroupedByDay = groupBy(activities, activity => get(activity, "common.day"))
    const journeyDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
    const [dragValue, setDragValue] = useState<boolean>(false);
    const timerRef = useRef<NodeJS.Timer>()
    const setScrollInterval = (speed: number, container: HTMLElement) => {
        timerRef.current = setInterval(() => {
            container.scrollBy(0, speed);
        }, 1);
    }
    // only needed because natively, if the Dnd Context is too close to the bounds of the container (div) its in, the
    // native auto scrolling of the browser does not work. Because of that, we must simulate it.
    useDndMonitor({
        onDragStart: () => setDragValue(true),
        onDragEnd: () => {
            setDragValue(false);
            if (timerRef.current) clearInterval(timerRef.current);
        },
        onDragMove: (event) => {
            if (!dragValue) return

            const container = document.getElementById("main-container");
            if (!container) return

            const offsetY = event.delta.y;
            const rect = container.getBoundingClientRect()

            if (offsetY < rect.top + 200) {
                if (timerRef.current) clearInterval(timerRef.current)
                setScrollInterval(-5, container);
            } else if (offsetY > rect.bottom - 200) {
                if (timerRef.current) clearInterval(timerRef.current)
                setScrollInterval(5, container);
            } else {
                if (timerRef.current) clearInterval(timerRef.current)
            }
        }
    });

    return journeyDurationInDays === null && (activities?.length === 0 || typeof activities === 'undefined') ?
        <div className={"journey-overview-no-days"}>
            <Text variant={"headlineMedium"}>SCREENS.JOURNEY.NO_DAY_TEXT</Text>
            <TextButton
                onClick={() => {
                    dispatch(addDayToJourney())
                    dispatch(addPersonToJourney(1))
                }}>
                SCREENS.JOURNEY.ADD_DAY_BUTTON
            </TextButton>
        </div> :
        <ul

            className="journey-overview-container">
            {journeyDurationInDays !== null && createArrayFromNumber(journeyDurationInDays).map(day => {
                const activitiesAtDay = typeof activitiesGroupedByDay[day] !== 'undefined' ? activitiesGroupedByDay[day] : []
                const dayString = day.toString()
                return <JourneyDayCard
                    journeyDuration={journeyDuration}
                    travelComponentActivities={travelComponentActivities}
                    draggingActivity={draggingActivity}
                    hasExactDates={hasExactDates}
                    onMouseEnter={activityGroupId => setHoveredId(activityGroupId)}
                    onMouseLeave={() => setHoveredId(null)}
                    onDeleteDay={onDeleteDay}
                    journeyDurationInDays={journeyDurationInDays}
                    onActivityDelete={onDeleteActivity}
                    onActivityArrowUp={activity => onActivityArrow(dayString, 'up', activity)}
                    onActivityArrowDown={activity => onActivityArrow(dayString, 'down', activity)}
                    activitiesAtDay={activitiesAtDay}
                    allActivities={activities ?? []}
                    isRecalculatingActivityEmissions={isRecalculatingActivityEmissions}
                    key={day}
                    day={day}
                    journeyPersonCount={journeyPersonCount}
                    onDayArrow={onDayArrow}
                    droppableZoneId={day.toString()}
                    altKeyPressed={altKeyPressed}
                    hoveredId={hoveredId}/>
            })
            }
            <li
                className={"journey-overview-no-days"}>
                <IconButton
                    aria-label={'TOOLTIP.JOURNEY.ADD_DAY'}
                    tooltip={'TOOLTIP.JOURNEY.ADD_DAY'}
                    size={'extraVeryLarge'}
                    icon={"plus"}
                    onClick={() => {
                        setAvoidRecalculationThroughUseEffect()
                        dispatch(changeJourneyDuration(journeyDurationInDays!! + 1))
                    }}/>
            </li>
        </ul>
}

export default JourneyOverview